

import React from "react"
import Layout from "../components/Layout"
import LoginPage from "../components/LoginPage"

const Login = () => (
	
  <Layout>
   
    <div style={{ maxWidth: '100%'}}> 
      <LoginPage/>
    </div>
    
  </Layout>
)

export default Login
